import { apiFetch } from './httpClient';
import { ProjectSummary } from '../core/types';

export function listProjects(): Promise<ProjectSummary[]> {
  return apiFetch<ProjectSummary[]>('/projects');
}

export function createProject(name: string, description?: string): Promise<ProjectSummary> {
  return apiFetch<ProjectSummary>('/projects', {
    method: 'POST',
    body: JSON.stringify({ name, description: description || undefined }),
  });
}
